const Footer = () => {
  return (
    <footer className="mt-5 text-center text-muted">
      <p>Copyright &copy;2022 Mav </p>
    </footer>
  );
};

export default Footer;
